import React from "react";
import StandingsConfigurationsList from "../../StandingsConfigurations/StandingsConfigurationsList";

const StandingsConfigurations = () => {
  return (
    <>
      <div className={"mb-2"}>
        <StandingsConfigurationsList />
      </div>
    </>
  );
};

export default StandingsConfigurations;
